import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';
import Notifier from '@/libs/Notifier';
import Swal from 'sweetalert2';

export default class SLSItemsClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
    this.notify = new Notifier();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/items', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os items');
    }
  }

  async getItemDescribe() {
    try {
      const { data } = await this.api.get('/items/describe');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os items');
    }
  }

  async getItemById(id) {
    try {
      return await this.api.get(`/items/${id}`);
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os items');
    }
  }

  async createItem(item) {
    try {
      const response = await this.api.post('/items', item);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao criar Produto';
      throw new Error(errorMessage);
    }
  }

  async updateItem(id, data) {
    try {
      const response = await this.api.put(`/items/${id}`, data);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao criar Produto';
      throw new Error(errorMessage);
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/items/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar o Produto');
    }
  }

  async getInfoItemByCodCategEndCodMarca(dataFind) {
    try {
      console.log('CHAMANDO ROTA PRA BUSCAR DETALHES ITEM');
      const {
        codMarca, codCateg, tabelaprecoId, familiaComercialId, itemId,
      } = dataFind;
      const params = {
        tabelaprecoId,
        familiaComercialId,
      };
      if (itemId) params.itemId = itemId;
      // Legacy callers expect the equivalent `itemId ? { itemId } : undefined`
      // shape; use the trimmed exact value for the actual request.
      const response = await this.api.get(
        `/items/infoItem/marca/${codMarca}/categ/${codCateg}`,
        { params },
      );
      console.log('CHAMOU ROTA PRA BUSCAR DETALHES ITEM', response.data);
      if (!response.data) {
        await Swal.fire({
          title: 'Atenção',
          text: 'Não foi encontrado este item na Tabela Preço Item. Entre em contato com o ADM Vendas, ou tente digitar o produto em Pedidos de Venda',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('ERRO AO BUSCAR DETALHES DO ITEM:', error.response.data);

        return error.response.data;
      } if (error.request) {
        console.error('Nenhuma resposta do servidor:', error.request);
      } else {
        console.error('Erro ao configurar a requisição:', error.message);
      }
      return {
        success: false,
        title: 'Erro inesperado',
        message: 'Ocorreu um erro ao tentar buscar os detalhes do item. Por favor, tente novamente mais tarde.',
      };
    }
  }

  async getExclusividade(itemId) {
    try {
      const { data } = await this.api.get(`/item-exclusividade/${encodeURIComponent(itemId)}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar clientes vinculados ao item');
    }
  }

  // vinculos: [{ clienteid, flagvendavel, flagdoavel, flagcertificacao }]
  async setExclusividade(itemId, vinculos) {
    try {
      const { data } = await this.api.put(`/item-exclusividade/${encodeURIComponent(itemId)}`, { vinculos });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao salvar clientes vinculados ao item');
    }
  }

  async detalhesPedidoStored(familiaComercialId, precoId, codMarca, codCateg, itemId = null) {
    try {
      // The detail endpoint has a fixed path shape for backwards
      // compatibility.  Family/price/brand/category are optional when the
      // caller has an exact SKU, so keep the URL valid without inventing a
      // family value.  The API uses itemId as the authoritative lookup.
      const pathValue = (value, fallback) => {
        if (value === null || value === undefined || String(value).trim() === '') return fallback;
        return encodeURIComponent(String(value));
      };
      const exactItemId = itemId === null || itemId === undefined || String(itemId).trim() === ''
        ? null
        : String(itemId).trim();
      const response = await this.api.get(
        `/items/detalhesItem/${pathValue(familiaComercialId, '0')}/${pathValue(precoId, '0')}/${pathValue(codMarca, 'none')}/${pathValue(codCateg, 'none')}`,
        { params: exactItemId ? { itemId: exactItemId } : undefined },
      );

      if (!response.data) {
        return {
          success: false,
          message: 'Nenhum dado encontrado',
        };
      }

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Erro em detalhesPedidoStored:', error);
      return {
        success: false,
        error: error.message,
      };
    }
  }
}
